import { Line } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto';

export const MonthlyEarningsChart = ({ data }) => {
  // Create a map of all months in the range to ensure no missing months
  const allMonths = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const earningsMap = new Map(data.map(item => [item.month.trim(), item.totalAmount]));

  const chartData = {
    labels: allMonths,
    datasets: [{
      label: 'Monthly Earnings',
      data: allMonths.map(month => earningsMap.get(month) || null), // Fill missing months with null
      borderColor: '#2196F3',
      tension: 0.4
    }]
  };

  return <Line data={chartData} />;
};